import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { FlexRowCenterVertical } from '../../../Defaults/Flexbox/Flexbox';
import { TextP } from '../../../Defaults/Text';
import { DotDelimeter } from '../../General/DotDelimeter';

interface Props {
  customNr: string;
  stockReadable: string;
  textColor?: string;
}

function CustomNrStock({ customNr, stockReadable, textColor }: Props) {
  return (
    <Wrapper>
      {customNr && <CustomNr>{customNr}</CustomNr>}
      {stockReadable && customNr && <DotDelimeter />}
      {stockReadable && (
        <StockReadable color={textColor}>{stockReadable}</StockReadable>
      )}
    </Wrapper>
  );
}

const Wrapper = styled(FlexRowCenterVertical)``;

const Text = styled(TextP)`
  font-family: ${({ theme }) => theme.font.tertiary};
  font-size: ${rem(12)};
  line-height: ${rem(16)};
  white-space: nowrap;
`;

const CustomNr = styled(Text)`
  color: ${({ theme }) => theme.colors.placeholder};
`;
const StockReadable = styled(Text)<{ color: string }>`
  color: ${({ color }) => color};
`;

export { CustomNrStock };
